import { Injectable } from '@angular/core';
import { ApiService } from './api.service';

@Injectable()
export class StorageService {

  storage = window.localStorage;
  data = [];

  constructor(
    private api: ApiService,
  ) {}

  set( key, value ) {
    this.storage.setItem( key, JSON.stringify(value) );
  }

  get( key ) {
    if ( key.match( /([A-Z]{2}[0-9]{9}[A-Z])\w+/gmi ) ) {
      return JSON.parse( this.storage.getItem( key ) );
    }
  }

  remove( key ) {
    this.storage.removeItem( key );
  }

  setTrack( track, value ) {
    return this.set( track, value );
  }

  getTrack( track ) {
    return this.get( track );
  }

  getKeys() {
    const keys = Object.keys( this.storage );
    const res = [];

    keys.forEach( val => {
      if ( val.match( /([A-Z]{2}[0-9]{9}[A-Z])\w+/gmi ) ) {
        res.push( this.getTrack(val) );
      }
    } );

    return res;
  }

  removeTrack( track ) {
    this.remove( track );
  }

  removeTracks() {
    this.storage.clear();
  }

  updateTrack( track ) {
    const old = track;

    this.api.getTrack( old[ 'track' ] )
      .subscribe( res => {

        /** Verifica se a quantidade de eventos recebido é maior que o atual, caso seja, atualiza localmente */
        console.log(res); 
        console.log(old); 
        if ( res[ 'eventsCount' ] > old[ 'eventsCount' ] ) {
          res[ 'description' ] = old[ 'description' ];
          res[ 'archived' ] = old[ 'archived' ];

          this.setTrack( old[ 'track' ], res );

        }

      } );
  }

  updateTracks() {
    const keys = this.getKeys();

    keys.forEach( val => {
      /** Se for diferente de 3, ou seja, não for typo 'entregue', atualiza os dados localmente */
      if ( val[ 'lastEvent' ] ) {
        if ( val[ 'lastEvent' ][ 'type' ] !== 3 ) {
          this.updateTrack( val );
          console.log(`update track`)
        }
      }
    } );

  }

}



// WEBPACK FOOTER //
// D:/DEV/angular/web-track-correios/src/service/storage.service.ts